import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganization } from '../OrganizationContext';
import BasePage from '../components/BasePage';
import Button from '../components/Button';
import { useDocumentTitle } from '../hooks/UseDocumentTitle';
import { useURLHelper } from '../urlhelper';

import './StartPage.css';


function StartPage(): React.ReactElement {
  const urlHelper = useURLHelper();
  const { t } = useTranslation<string>();
  const org = useOrganization();

  useDocumentTitle({ title: 'Home' });

  return (
    <BasePage>
      {org.operatingMessage && (
        <div className="OperatingMessage">
          {org.operatingMessage.localize()}
        </div>
      )}
      <div className="StartPage">
        {org.functionalityConfig.activateAccount() && (
          <Button big linkTo={urlHelper.activate()}>
            {t('Activate account')}
          </Button>
        )}
        {org.functionalityConfig.forgotPassword() && (
          <Button big linkTo={urlHelper.passwordChange()}>
            {t('Forgot password')}
          </Button>
        )}
        {org.functionalityConfig.loginAccount() && (
          <Button big linkTo={urlHelper.profile()}>
            {t('My Account')}
          </Button>
        )}
      </div>
    </BasePage>
  );
}

export default StartPage;
